import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ArrowLink.scss';

class ArrowLink extends Component {
  static propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    dataTestId: PropTypes.string
  };

  render() {
    var titleClass = classNames({
      arrow__link: true,
      link: !!this.props.onClick,
      [`${this.props.className}`]: !!this.props.className
    });
    return (
      <div className={titleClass} onClick={this.props.onClick} data-testid={this.props.dataTestid}>
        {this.props.title} {this.props.onClick ? <span className="arrow__link--carat">&gt;</span> : null}
      </div>
    );
  }
}

export default ArrowLink;
